<template>
  <div id="studenttrackrecord" style="margin-top: -26px; border-top: 1px solid #eee">
    <div class="fail" v-if="isShowFail">当前学员还未添加跟踪记录！</div>
    <div class="scroll" v-loading="isLoading" v-if="!isShowFail">
      <div class="process_content">
        <div class="steps" v-for="item in studentTracksRecord">
          <div class="left_steps_time">
            <div class="steps_time">
              <p>{{ item.trackTime[0] }}</p>
              <p>{{ item.trackTime[1] }}</p>
            </div>
            <div class="icon_clock">
              <i class="el-icon-time"></i>
            </div>
          </div>
          <div class="steps_content">
            <!-- <div> <span class="font_status green_status">已报名</span> </div> -->
            <!-- <div> <span class="font_status gray_status">待跟踪</span> <span class="fl_r">下次跟踪时间：{{item.nextTime}}</span> -->
            <!-- </div> -->
            <div class="nextTime">下次跟踪时间：{{ item.nextTime }}</div>
            <div class="flex_text">
              <div>跟踪老师：</div>
              <div class="flex_div">
                {{ item.businessName ? item.businessName : "未设置" }}
              </div>
            </div>
            <div class="flex_text">
              <div>当前问题：</div>
              <!-- <div v-if="/.(png|jpg|jpeg|gif)$/g.test(item.problem)" class="pointer">
                <a @click="imgcheck(item.problem)"><i class="el-icon-thumb"></i>点击查看</a>
              </div> -->
              <el-image v-if="/.(png|jpg|jpeg|gif|JPG)$/g.test(item.problem?.split('?')[0])" class="table-column-img" :src="item.problem"
                :preview-src-list="[item.problem]" :z-index="zindex">
              </el-image>
              <div v-else class="flex_div">{{ item.problem }}</div>
            </div>
            <div class="flex_text">
              <div>解决方法：</div>
              <el-image v-if="/.(png|jpg|jpeg|gif|JPG)$/g.test(item.desp?.split('?')[0])" class="table-column-img" :src="item.desp"
                :preview-src-list="[item.desp]" :z-index="zindex">
              </el-image>
              <div v-else-if="item.desp" class="flex_div">{{ item.desp }}</div>
              <div v-else class="gray">暂无</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStudentTracksRecord } from "../../../network/studentsTrack.js";
import { timeFormatNew } from "../../../common/utils.js";
export default {
  name: "studentTrackRecord",
  props: {
    studentId: Number|String,
    BusinessId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      zindex: 9999, //图片层级
      isLoading: false,
      isShowFail: false,
      dialogVisibleImg: false, //查看学员问题图片
      studentTrankImg: "", //查看大图轮播图
      studentTracksRecord: {}, //学员跟踪记录
      studentName: "", //学员姓名

    };
  },
  computed: {
    // 获取当前登录管理员的身份ID
    // BusinessIdNew(){
    //    return (
    //     this.$store.state.AdminCache.rolesId || sessionStorage.getItem("AdminCache").roleId
    //   );
    // }
  },
  created() {

    //查看指定学员跟踪记录
    var StudentId = this.studentId;

    var obj = {
      StudentId: StudentId,
      BusinessId: this.BusinessId,
      PageIndex: 1,
      PageSize: 50,
    };
    this.getStudentTracks(obj);
  },
  methods: {
    //获取指定学员跟踪记录
    async getStudentTracks(id) {
      this.isLoading = true;
      const result = await getStudentTracksRecord(id);
      if (result && result.code == 1) {
        this.isLoading = false;
        if (result.data.length > 0) {
          this.isShowFail = false;
          this.studentTracksRecord = result.data;
          this.studentName = this.studentTracksRecord[0].studentName;
          // 把学员姓名传给父
          this.$emit("tranktitle", this.studentName);
          this.studentTracksRecord.forEach(function (e) {
          if(e.trackTime.indexOf("T")>-1){
            e.trackTime = e.trackTime.split("T");
          }else{
            e.trackTime = e.trackTime.split(" ");
          }  
            e.nextTime = timeFormatNew(e.nextTime, "yyyy-MM-dd hh:mm");
          });

        } else {
          this.isLoading = false;
          this.isShowFail = true;
        }
      } else {
        this.isLoading = false;
        this.isShowFail = true;
      }
    },
    //查看图片
    // imgcheck(img) {
    //   this.dialogVisibleImg = true;
    //   this.studentTrankImg = img;
    // },
    handleClose(done) {
      //不能点击外面关闭
      //也不需要确定
      done();
    },
    jiema1(val) {
      let ma = this.setHtmlImg(decodeURIComponent(val));
      return ma;
    },
    // 处理富文本图片
    setHtmlImg(content) {
      let html = content
        .replace(/\"/g, '\'')
        .replace(/<img/ig, "<img style='width:100%;height:100%;display:block;'")
      return html
    },
  },
};
</script>

<style scoped>
.fail {
  margin-top: 150px;
  text-align: center;
  color: #959595;
}

.el-icon-time {
  font-size: 22px;
  color: #999;
}

.scroll {
  height: 400px;
  /* height: auto; */
  overflow-y: scroll;
}

.process_content {
  position: relative;
  padding: 25px 60px 0 126px;
  background-color: #fff;
}

.process_content::before {
  content: "";
  display: block;
  width: 2px;
  height: 90%;
  background-color: #ebebeb;
  position: absolute;
  left: 102px;
  top: 45px;
}

.steps {
  padding-bottom: 30px;
}

.left_steps_time {
  position: relative;
  left: -136px;
  top: -4px;
  font-size: 14px;
}

.steps_time {
  display: inline-block;
  text-align: right;
  position: absolute;
  left: 10px;
  top: 1px;
  color: #607080;
}

.icon_clock {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 104px;
  margin-left: -3px;
  background-color: #fff;
}

.steps_content {
  position: relative;
  top: -6px;
  font-size: 14px;
}

.steps_text p {
  line-height: 28px;
  font-size: 16px;
}

.font_status {
  font-size: 16px;
}

.green_status {
  color: #67c23a;
}

.gray_status {
  color: #999;
}

.flex_text {
  width: 100%;
  margin-top: 3px;
  text-align: left;
  display: flex;
  flex-direction: row;
}

.flex_text div:first-child {
  color: #999;
}

.flex_div {
  flex: 1;
  color: #303133;
}

.nextTime {
  position: absolute;
  right: 0;
  color: #f56c6c;
}

.pointer {
  cursor: pointer;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #fff !important;
}

.table-column-img {
  width: 80px;
  height: 100%;
  border: 1px solid #dcdfe6;
}

#studenttrackrecord>>>.el-image__error,
#studenttrackrecord>>>.el-image__inner,
#studenttrackrecord>>>.el-image__placeholder {
  width: 80px;
  height: 80px;
}
.gray{
  color: gray;
}
</style>